import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LanguageSwitcherComponent],
  imports: [CommonModule, TranslateModule, IonicModule, FormsModule],
  exports: [LanguageSwitcherComponent, TranslateModule],
})
export class SharedModule {}
